// extracted by mini-css-extract-plugin
export default {"new_limit_wrap":"MobileView_new_limit_wrap__tys9R","text":"MobileView_text__LwaJA","button_container":"MobileView_button_container__+7IAf"};